import type { SVGProps } from 'react';

export const Lock = (props: SVGProps<any>) => (
  <svg 
    fill="white" 
    height="20" 
    viewBox="0 0 20 20" 
    width="20" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{'Lock'}</title>
    <path d="M5.833 8.333V6.666a4.167 4.167 0 1 1 8.334 0v1.667" stroke="#3D57FF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
    <rect height="8.334" rx="2" stroke="#3D57FF" strokeWidth="1.5" width="13.334" x="3.333" y="8.333"/>
    <circle cx="10" cy="12.5" fill="#3D57FF" r="1.25"/>
  </svg>
);
